var map = {
	"./agenda2030.svg": 35286,
	"./ai.svg": 794419,
	"./citizenPortal.svg": 327726,
	"./doBoard.svg": 350215,
	"./eLearning.svg": 32210,
	"./governmentGrants.svg": 523103,
	"./grc.svg": 464514,
	"./healthSafety.svg": 483372,
	"./home.svg": 122015,
	"./informationSecurity.svg": 971343,
	"./integrations.svg": 275855,
	"./internalAudit.svg": 116975,
	"./internalControl.svg": 686331,
	"./meetings.svg": 975496,
	"./nationalQualitySystemForSchools.svg": 296401,
	"./operationalPlanning.svg": 585606,
	"./projects.svg": 41898,
	"./qualityManagement.svg": 386958,
	"./qualityManagementForSchools.svg": 271283,
	"./qualityManagementISO9001.svg": 157803,
	"./resourcePlanning.svg": 357035,
	"./riskAndControl.svg": 960535,
	"./riskManagement.svg": 299303,
	"./sosfs.svg": 265397,
	"./strategicPlanning.svg": 350752,
	"./strategicPlanning2021.svg": 697740,
	"./sustainability.svg": 213668
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 543543;